import { connect } from "react-redux";
import { LoginPage } from "../components/LoginPage";
import { RouteComponentProps } from "react-router";

export interface OwnProps extends RouteComponentProps<any> {
    auth: any;
}

const mapDispatchToProps = (dispatch: any, { auth, match, history }: OwnProps) => ({
    handleLogin: () => {
        const { location } = history;
        const startUrl = location.pathname + location.search;

        auth.login(startUrl);
    },
});

export const LoginPageContainer = connect(null, mapDispatchToProps)(LoginPage);
